import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getPerformance } from 'firebase/performance';

const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const perf = getPerformance(app);
export default app;

export const getEnvironment = () => {
    // You can add VITE_ENVIRONMENT to your .env files
    // If not set, fallback to checking if we're in development mode
    return import.meta.env.VITE_ENVIRONMENT || (import.meta.env.DEV ? 'dev' : 'prod');
};

export const getUserCollection = (userId: string, collectionName: string) => {
    const env = getEnvironment();
    return `users-${env}/${userId}/${collectionName}`;
};

export const getTopLevelCollection = (collectionName: string) => {
    const env = getEnvironment();
    return `${collectionName}-${env}`;
}; 